<ng-template #priceDialog let-data>
    <ipm-price [priceData]="data" 
    (isPlayMusic)="onChangePlayData($event)" 
    (isNegotiation)="onTriggerNegotiationFn($event)" 
    (purchaseEventTrigger)="soundPurchaseEventHandle($event)"
    (orderSuccessEvent)="showOrderPurchaseSuccess($event)"></ipm-price>
</ng-template>
<ng-template #sharedDialog let-data>
    <ipm-share-beat [shareData]="data"></ipm-share-beat>
</ng-template>
<ng-template #filterDialog let-data>
    <ipm-filter-beat (emitSortFilter)="sortEventTrigger($event)" [isComponentType]="isComponentType" [geneFilterList]="genereFilter" [activeTabIndex]="data?.activeTabIndex || 0"></ipm-filter-beat>
</ng-template>
<ng-template #downloadDialog let-data>
    <ipm-download-beat [producerData]="data"></ipm-download-beat>
</ng-template>
<ng-template #creditPurchase let-data>
    <ipm-credit-popup [currentSoundData]="data"
     (orderSuccessEvent)="showOrderPurchaseSuccess($event)">
    </ipm-credit-popup>
</ng-template>

<ng-template #paymentSuccessPopup let-data>
    <ipm-payment-success [type]="data.popType"
        [message]="data.message"
        [isShowButton]="true"
        (isCloseButtonEvent)="closePopup($event)"
        [buttonText]="data?.buttonText">
    </ipm-payment-success>
</ng-template>

<ng-template #lyricsDialog let-data>
    <ipm-lyrics-editor [beat]="data.beat" [initialVersion]="data.initialVersion"></ipm-lyrics-editor>
</ng-template>

<ng-template #basicCreditInfoDialog>
    <div class="confirmation-pop">
        <div class="ipm-close-icon">
            <i class="pi pi-times" (click)="closeUpgradePlanPopup()"></i>
        </div>
        <div class="confirmation-pop-body">
            <div class="check-section">
                <span class="icon">!</span>
            </div>
            <p class="sub-heading text-center text-white mt-4">
                Credits are not available on the Basic plan. Upgrade to use credits.
            </p>
            <div class="actions ipm-actions">
                <button class="btn ipm-submit-btn" type="button" (click)="goToSubscriptionsFromCreditInfo()">
                    Upgrade plan
                </button>
            </div>
        </div>
    </div>
</ng-template>
